import { render, staticRenderFns } from "./view-recored-files.vue?vue&type=template&id=12b0d62e&scoped=true"
import script from "./view-recored-files.vue?vue&type=script&lang=ts"
export * from "./view-recored-files.vue?vue&type=script&lang=ts"
import style0 from "./view-recored-files.vue?vue&type=style&index=0&id=12b0d62e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0d62e",
  null
  
)

export default component.exports